<template>
  <div class="w-full">
    <div class="flex">
      <div class="relative shrink-0">
        <button 
          :id="dropdownButtonId" 
          @click="toggleDropdown"
          class="z-10 inline-flex items-center py-2 px-3 text-sm rounded-lg font-medium text-center text-custom_gray bg-gray-100 border border-gray-300 hover:bg-gray-200 focus:ring-2 focus:outline-none focus:ring-gray-100" 
          type="button"
        >
          <img v-if="(modelValue && modelValue === 'USD') || (currency?.code === 'USD')" src="@/assets/imgs/Currencies/USD.svg" alt="USD" class="h-4 w-4 me-2">
          <img v-if="(modelValue && modelValue === 'MXN') || (currency?.code === 'MXN')" src="@/assets/imgs/Currencies/MXN.svg" alt="MXN" class="h-4 w-4 me-2">
          <img v-if="(modelValue && modelValue === 'EUR') || (currency?.code === 'EUR')" src="@/assets/imgs/Currencies/EUR.svg" alt="EUR" class="h-4 w-4 me-2">
          {{ modelValue || currency?.code || 'Moneda' }} 
          <svg 
            class="w-2.5 h-2.5 ms-2.5" 
            aria-hidden="true" 
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 10 6"
            :class="['transition-transform duration-200 shrink-0', showDropdown ? 'rotate-180' : '']"
          >
            <path 
              stroke="currentColor" 
              stroke-linecap="round" 
              stroke-linejoin="round" 
              stroke-width="2" 
              d="m1 1 4 4 4-4"
            />
          </svg>
        </button>
        <div 
          :id="dropdownId" 
          v-show="showDropdown"
          :class="dropdownClasses"
        >
          <ul class="py-2 text-sm text-gray-700 dark:text-gray-200" :aria-labelledby="dropdownButtonId">
            <li v-for="option in currencyOptions" :key="resolveOption(option).code">
              <button 
                type="button" 
                @click="selectCurrency(resolveOption(option))"
                class="inline-flex w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" 
                role="menuitem"
              >
                <div class="inline-flex items-center">
                  <template v-if="resolveOption(option).code === ''">
                    <span>Ver Todo</span>
                  </template>
                  <!-- Opciones con moneda -->
                  <template v-else>
                    <img v-if="resolveOption(option).code === 'USD'" src="@/assets/imgs/Currencies/USD.svg" alt="USD" class="h-4 w-4 me-2">
                    <img v-if="resolveOption(option).code === 'MXN'" src="@/assets/imgs/Currencies/MXN.svg" alt="MXN" class="h-4 w-4 me-2">
                    <img v-if="resolveOption(option).code === 'EUR'" src="@/assets/imgs/Currencies/EUR.svg" alt="EUR" class="h-4 w-4 me-2">
                    {{ resolveOption(option).code }}
                  </template>
                </div>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import axios from 'axios'

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: ''
  },
  currency: {
    type: Object,
    default: null
  },
  dropdownAlign: {
    type: String,
    default: 'left',
    validator: (value) => ['left', 'right'].includes(value)
  }
})
const currencyOptions = ref([]);
const emit = defineEmits(['update:modelValue', 'update:currency', 'currencies-loaded', 'change'])

const showDropdown = ref(false)

const dropdownId = computed(() => `dropdown-${props.inputId}`)
const dropdownButtonId = computed(() => `dropdown-${props.inputId}-button`)

const dropdownClasses = computed(() => {
  const baseClasses = 'absolute top-full mt-1 z-10 bg-white divide-y divide-gray-100 rounded-lg shadow-lg md:w-[104px] w-full dark:bg-gray-700'
  if (props.dropdownAlign === 'right') {
    return `${baseClasses} right-0`
  }
  return `${baseClasses} left-0`
})

function resolveOption(option) {
  return option.value || option
}

function toggleDropdown() {
  showDropdown.value = !showDropdown.value
}

function selectCurrency(selectedCurrency) {
  emit('update:currency', selectedCurrency)
  emit('update:modelValue', selectedCurrency.code)
  emit('change', selectedCurrency.code)

  showDropdown.value = false
}

function onDocumentClick(event) {
  const dropdown = document.getElementById(dropdownId.value)
  const button = document.getElementById(dropdownButtonId.value)
  
  if (dropdown && button && !dropdown.contains(event.target) && !button.contains(event.target)) {
    showDropdown.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', onDocumentClick)
})

async function getCurrencies() {
  const url = `${process.env.VUE_APP_API_BASE_URL}/catalogue/type_currencies`
  const options = {
    headers: { 'Content-Type': 'application/json' }
  }

  try {
    const response = await axios.get(url, options)
    if (response.status === 200 && Array.isArray(response.data.resp)) {
      currencyOptions.value = [{ code: '', name: 'Ver Todo' }, ...response.data.resp.map(currency => ({
        code: currency.code,
        name: `${currency.name} (${currency.code})`
      }))]

      emit('currencies-loaded', currencyOptions.value)
    } else if (response.status === 401) {

      console.warn('Unauthorized while fetching currencies')
    }
  } catch (error) {
    console.error('Error loading currencies:', error)
  }
}

defineExpose({ getCurrencies })

onMounted(() => {
  getCurrencies()
})

onUnmounted(() => {
  document.removeEventListener('click', onDocumentClick)
})

watch(() => props.modelValue, () => {
  
})
</script>